import { render, staticRenderFns } from "./prg.vue?vue&type=template&id=6bfdcda6&scoped=true&"
import script from "./prg.vue?vue&type=script&lang=js&"
export * from "./prg.vue?vue&type=script&lang=js&"
import style0 from "./prg.vue?vue&type=style&index=0&id=6bfdcda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfdcda6",
  null
  
)

export default component.exports